import Scrollbars, { ScrollbarProps } from 'react-custom-scrollbars';
import { ReactNode, useCallback } from 'react';
import { useTheme } from '@mui/material';

import { useScrollableContainerStyles } from './ScrollableContainerStyles';

export interface ViewProps {
  style: React.CSSProperties;
}

export interface ScrollableContainerProps extends ScrollbarProps {
  children?: ReactNode;
}

export const ScrollableContainer = ({
  children,
  ...props
}: ScrollableContainerProps) => {
  const theme = useTheme();
  const scrollWidth = theme.spacing(3);

  const { classes } = useScrollableContainerStyles(scrollWidth);

  const renderView = useCallback(
    (viewProps: ViewProps) => <div {...viewProps} className={classes.view} />,
    [classes.view],
  );

  return (
    <Scrollbars
      {...props}
      renderView={renderView}
      style={{
        width: `calc(100% + ${scrollWidth})`,
      }}
    >
      {children}
    </Scrollbars>
  );
};
